import React, { useEffect, useState } from "react";
import BaseModalAnimated from "../../../components/modal/BaseModalAnimated";
import CustomButton from "../../../components/form/CustomButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../components/form/CustomInput";
import { showFormErrors } from "../../../helpers/showFormErrors";
import { useSelector } from "react-redux";

const AddUpdModal = ({ modal, setModal, load }) => {
    const { load_paymentValidations, load_payment } = useSelector(state => state.LoadPayment)
console.log(load_payment)
    const validation = useFormik({
        initialValues: load_payment,
        validationSchema: Yup.object(load_paymentValidations),
        onSubmit: async (values, { setErrors, resetForm }) => {
            let id = values.id;

            values._idbase = id;
            if (!id) {
                // id local para frontend
                id = Math.floor(10000 + Math.random() * 90000);
            }


            values.local_id = id;
            values.id = id;
            

            const payments = load.values.payments || [];


            const updated = payments.some(p => p.local_id === values.local_id)
                ? payments.map(p =>
                    p.local_id === values.local_id ? values : p
                )
                : [...payments, values];


            load.setFieldValue('payments', updated);
            setModal({ ...modal, show: false });
        }
    });

    return (
        <>
            <BaseModalAnimated modal={modal} setModal={setModal}>
                <div className="p-6 space-y-6">

                    {/* Header */}
                    <div className="flex flex-col gap-1">
                        <p className="text-sm uppercase tracking-[0.16em] text-cs-primary-dark">
                            Payment concept
                        </p>
                        <p className="text-sm text-cs-muted">
                            Define the payment concept and amount that will be added to this load.
                        </p>
                    </div>

                    {/* Form */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <CustomInput
                            label="Concept"
                            type="text"
                            name="concept"
                            labelClassName="text-xs font-medium text-cs-dark"
                            error={validation?.errors?.concept}
                            value={validation?.values?.concept}
                            handleChange={validation.handleChange}
                        />

                        <CustomInput
                            label="Amount"
                            type="number"
                            name="amount"
                            labelClassName="text-xs font-medium text-cs-dark"
                            error={validation?.errors?.amount}
                            value={validation?.values?.amount}
                            handleChange={validation.handleChange}
                        />
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end pt-4 border-t border-cs-border">
                        <CustomButton
                            type="button"
                            onClick={() => validation.handleSubmit()}
                            className="
                    inline-flex items-center gap-2
                    px-5 py-2.5
                    rounded-xl
                    bg-cs-primary hover:bg-cs-primary-hover
                    text-white text-sm font-medium
                    shadow-md hover:shadow-lg
                    transition-all
                "
                        >
                            Save concept
                        </CustomButton>
                    </div>

                </div>
            </BaseModalAnimated>
        </>
    );
};
export default AddUpdModal;
